import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dc8f0070"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "profile-container"
};
const _hoisted_2 = {
  class: "flex-container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text"
}, "Personal information"), /*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text-info"
}, "Provide your basic details")], -1));
const _hoisted_4 = {
  class: "flex-item flex-item priority-high"
};
const _hoisted_5 = {
  class: "flex-container"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text"
}, "Change password")], -1));
const _hoisted_7 = {
  class: "flex-item flex-item priority-high"
};
const _hoisted_8 = {
  class: "flex-container"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text"
}, "Notification Settings"), /*#__PURE__*/_createElementVNode("span", {
  class: "block profile-text-info"
}, "Configure the notifications that you want to receive")], -1));
const _hoisted_10 = {
  class: "flex-item flex-item priority-high"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_profile_information = _resolveComponent("profile-information");
  const _component_profile_password = _resolveComponent("profile-password");
  const _component_profile_notification_settings = _resolveComponent("profile-notification-settings");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    contentPadding: "0 14px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_profile_information)])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_profile_password)])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_profile_notification_settings)])])])]),
    _: 1
  });
}